import { Component, Input, OnChanges } from '@angular/core';
import { Award } from '@df/interfaces';
import { AWARD_CARD_TYPES } from '@app/app.constants';

@Component({
    selector: 'app-award',
    templateUrl: './award.component.html',
    styleUrls: ['./award.component.scss']
})
export class AwardComponent implements OnChanges {
    @Input() award: Award = {
        comment: '',
        date: new Date(),
        for_what: '',
        urls: [],
        standart_card: null,
        named_card: null,
        certificate: null,
        user_id: null,
        count_cards: 0
    };
    @Input() awardCard: any;
    @Input() awardCardType: any;

    private clearPrevAwardCard(): void {
        this.award.standart_card = null;
        this.award.named_card = null;
        this.award.certificate = null;
    }

    private checkType(): void {
        if (this.awardCardType.title === AWARD_CARD_TYPES.STANDART_CARD) {
            this.award.standart_card = this.awardCard;
        }

        if (this.awardCardType.title === AWARD_CARD_TYPES.NAMED_CARD) {
            this.award.named_card = this.awardCard;
        }

        if (this.awardCardType.title === AWARD_CARD_TYPES.CERTIFICATE) {
            this.award.certificate = this.awardCard;
        }
    }

    ngOnChanges(): void {
        if (!this.award.user_id) {
            this.clearPrevAwardCard();
            this.checkType();
        }
    }
}
